import BackendService from '@/services/Backend'
import buildURL from 'axios/lib/helpers/buildURL'

import { isRequired } from '@/utils/CustomErrors'

class UserRegistryService extends BackendService {
  constructor(baseUrl, interceptor) {
    super(baseUrl, '/userregistry/public/v1', interceptor)
  }

  checkState({ partnerNumber = isRequired('partnerNumber') }) {
    return this.post('/identity-verification/state', { partnerNumber })
  }

  startVerificationProcess({ partnerNumber = isRequired('partnerNumber') }) {
    const action = 'ONLINE'
    const forceReset = true
    const url = buildURL('/identity-verification/process', { action, forceReset })
    return this.post(url, { partnerNumber })
  }

  verifyAnswer({
    answerKey = isRequired('answerKey'),
    partnerNumber = isRequired('partnerNumber'),
    questionKey = isRequired('questionKey'),
    questionPosition = isRequired('questionPosition'),
  }) {
    return this.post('/identity-verification/question', {
      answerKey,
      partnerNumber,
      questionKey,
      questionPosition,
    })
  }

  verifyCard({ answerText = isRequired('answerText'), partnerNumber = isRequired('partnerNumber') }) {
    return this.post('/identity-verification/card', {
      answerText,
      partnerNumber,
    })
  }
}

export default UserRegistryService
